// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"88a7673d","60":"ba2e8912","158":"0a1c5a9f","165":"f4d88f95","213":"f4de370c","411":"d6379ca2","433":"c51e124c","455":"63c8c858","542":"d5e02e7c","782":"f60559ef"}[chunkId] + ".chunk.js";
};